import React, {
  useRef, useEffect, useState, MouseEvent,
} from 'react';
import {Search, XLg} from 'react-bootstrap-icons';
import {QEPInput} from '../QEPInput/qep-input';
import './Searchfield.scss';

export interface SearchfieldProps {
  search?: string;
  placeholder?: string;
  className?: string;
  onChange: (searchTerm: string) => void;
  onClear: (evt?: MouseEvent<SVGElement> | React.MouseEvent<any>) => void;
  shouldReset?: boolean;
}

export function Searchfield({
  search = '',
  placeholder,
  className,
  onChange,
  onClear,
  shouldReset = false,
}: SearchfieldProps) {
  const inputField = useRef<HTMLInputElement>(null);

  const [searchTerm, setSearchTerm] = useState<string>(search);

  const handleClear = (e?: MouseEvent<SVGElement>) => {
    setSearchTerm('');
    onClear(e);
  };

  useEffect(() => {
    if (shouldReset) {
      handleClear();
    }
  }, [shouldReset]);

  useEffect(() => {
    onChange(searchTerm);
  }, [onChange, searchTerm]);

  return (
    <div className={`qep-searchfield ${className}`}>
      <Search className='overlay-icons left' />
      <QEPInput
        ref={inputField}
        className='prepend-icon'
        value={searchTerm}
        type='text'
        placeholder={placeholder}
        onChange={e => {
          setSearchTerm(e.target.value);
        }}
      />
      {searchTerm && (
        <XLg className='overlay-icons right clear' onClick={handleClear}/>
      )}
    </div>
  );
}
